import { render } from "./work-section.vue?vue&type=template&id=79fe65be"
import script from "./work-section.vue?vue&type=script&lang=js"
export * from "./work-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__